// 100Totes add-on cards (配件加购第 3 段, 方案 C: add-ons are never volume-discounted).
// Data: snippets/totes-addons.liquid -> [data-totes-addons-data]. Allowed keys come only from custom.addons.
// Cart: the bag line and its add-on lines go to /cart/add in ONE request (all-or-nothing, verified live
// 2026-10-27), linked by a hidden _addon_group property; assets/totes-addons-cart.js keeps them in step.
// Fail-closed: if a selected combination has no purchasable variant, Add to cart is blocked with a message
// instead of silently adding the bag without the add-ons.
(function (global, doc) {
  'use strict';
  if (global.TotesAddons) return;

  // key -> page name (= variant title fragment in product bag-add-ons) and exclusive group.
  var DEFS = [
    {key: 'zipper', name: 'Zipper', group: 'closure'},
    {key: 'magnetic_snap', name: 'Magnetic Snap', group: 'closure'},
    // renamed from "Inner Pocket" 2026-10-31 (boss): the open, no-closure pocket
    {key: 'inner_pocket', name: 'Open Pocket', group: 'pocket'},
    {key: 'zipper_pocket', name: 'Zipper Pocket', group: 'pocket'},
    {key: 'reinforced_handles', name: 'Reinforced Handles', group: 'handles'},
    {key: 'woven_label', name: 'Woven Label', group: 'label', hint: '100+ pcs'},
    // 2026-10-27, part of the combo product; renamed from "Individual Clear Bag" 2026-10-28 (boss)
    {key: 'clear_bag', name: 'Individually Packaged', group: 'packaging', hint: 'clear OPP bag each'}
  ];
  var BY_KEY = {};
  DEFS.forEach(function (d) { BY_KEY[d.key] = d; });
  var COMBO_GROUPS = ['closure', 'pocket', 'handles', 'packaging'];   // variant titles join names in this order with " + "
  var GROUP_WORD = {closure: 'closure', pocket: 'pocket'};
  // [boss 2026-10-31] Always expanded, compact: cards grouped under plain titles, in DEFS order within each section.
  var SECTIONS = [
    {title: 'Closure', groups: ['closure']},
    {title: 'Pocket', groups: ['pocket']},
    {title: 'Extras', groups: ['handles', 'label', 'packaging']}
  ];
  // Title row: ONE icon + word chip (the first add-on this bag offers, in this order), then "»" if more cards exist.
  var SVG = '<svg width="22" height="16" viewBox="0 0 40 28" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var CHIPS = [
    {label: 'Zipper', keys: ['zipper'], icon: SVG + '<rect x="2" y="10" width="8" height="8" rx="2"/><path d="M4.5 14h3"/>' +
      '<path d="M10 14h4"/><path d="M14 11v6M17 11v6M20 11v6M23 11v6"/><path d="M14 14h11"/><path d="M25 14l11-8M25 14l11 8"/>' +
      '<path d="M28 11.8v-2M31 9.6v-2M28 16.2v2M31 18.4v2"/></svg>'},
    {label: 'Pocket', keys: ['inner_pocket', 'zipper_pocket'], icon: SVG + '<path d="M9 4h22v15l-11 6-11-6z"/>' +
      '<path d="M12 7h16v10.5l-8 4.5-8-4.5z" stroke-dasharray="1.6 1.6"/><path d="M9 8h22"/></svg>'},
    // [Codex R20 P2-1] short chip word so the title row fits one line on a 375px phone; the card keeps the full name
    {label: 'Packaged', keys: ['clear_bag'], icon: SVG + '<rect x="7" y="2" width="26" height="24" rx="2"/>' +
      '<path d="M7 7h26"/><path d="M7 5h26" stroke-dasharray="1.2 1.6"/><path d="M13 12h14l-1.5 11h-11z"/>' +
      '<path d="M17 12v-1.5a3 3 0 0 1 6 0V12"/></svg>'}
  ];
  var boxes = new Map(), boundForms = new WeakSet();

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function parse(box) {
    var el = box.querySelector('[data-totes-addons-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function index(data) {
    var combos = {};
    (data.variants || []).forEach(function (v) {
      if (v && typeof v.title === 'string' && typeof v.id === 'number' && typeof v.price === 'number') combos[v.title] = v;
    });
    var cards = [];
    (Array.isArray(data.allowed) ? data.allowed : []).forEach(function (key) {
      var def = BY_KEY[key];
      if (!def || cards.some(function (c) { return c.key === key; })) return;
      var src = key === 'woven_label' ? data.label : combos[def.name];
      if (!src || src.available !== true || typeof src.price !== 'number') return;
      cards.push({key: key, name: def.name, group: def.group, price: src.price, image: src.image || null});
    });
    return {combos: combos, cards: cards};
  }

  function scopeOf(box) { return box.closest('product-info') || box.closest('section') || doc; }

  function qtyOf(box) {
    var input = scopeOf(box).querySelector('input[name="quantity"]');
    var n = input ? parseInt(input.value, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  function comboTitle(selected) {
    var names = [];
    COMBO_GROUPS.forEach(function (g) {
      DEFS.forEach(function (d) { if (d.group === g && selected.has(d.key)) names.push(d.name); });
    });
    return names.join(' + ');
  }

  // {combo, label, cents, names, ok} for the current selection. ok=false => must not add to cart.
  function resolve(state) {
    var title = comboTitle(state.selected), out = {combo: null, label: null, cents: 0, ok: true, names: []};
    if (title) {
      var v = state.idx.combos[title];
      if (!v || v.available !== true) out.ok = false;
      else { out.combo = v; out.cents += v.price; }
      out.names = title.split(' + ');
    }
    if (state.selected.has('woven_label')) {
      var lab = state.data.label;
      if (!lab || lab.available !== true) out.ok = false;
      else { out.label = lab; out.cents += lab.price; }
      out.names.push('Woven Label');
    }
    return out;
  }

  function notice(state, text) { state.noticeEl.textContent = text || ''; }

  function render(state) {
    var box = state.box, qty = qtyOf(box), min = state.data.labelMin || 100, r = resolve(state);
    state.cardsEl.querySelectorAll('[data-key]').forEach(function (btn) {
      var key = btn.getAttribute('data-key'), on = state.selected.has(key);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (key === 'woven_label') btn.setAttribute('aria-disabled', qty < min ? 'true' : 'false');
    });
    state.summaryEl.textContent = r.names.length ? r.names.join(', ') + ' · +' + money(r.cents) + ' / bag' : '';
  }

  function enforceLabel(state, qty) {
    var min = state.data.labelMin || 100;
    if (state.selected.has('woven_label') && (typeof qty === 'number' ? qty : qtyOf(state.box)) < min) {
      state.selected.delete('woven_label');
      notice(state, 'Woven Label needs at least ' + min + ' pcs, so it was removed. Raise the quantity to add it again.');
      return true;
    }
    return false;
  }

  function toggle(state, key) {
    var def = BY_KEY[key];
    if (!def) return;
    if (state.selected.has(key)) { state.selected.delete(key); notice(state, ''); render(state); return; }
    if (key === 'woven_label' && qtyOf(state.box) < (state.data.labelMin || 100)) {
      notice(state, 'Woven Label is available from ' + (state.data.labelMin || 100) + ' pcs.');
      render(state); return;
    }
    var replaced = null;
    if (GROUP_WORD[def.group]) {
      DEFS.forEach(function (d) {
        if (d.group === def.group && d.key !== key && state.selected.has(d.key)) { state.selected.delete(d.key); replaced = d; }
      });
    }
    state.selected.add(key);
    notice(state, replaced ? def.name + ' replaces ' + replaced.name + ' — a bag can have only one ' + GROUP_WORD[def.group] + ' option.' : '');
    render(state);
  }

  function span(cls, text) { var s = doc.createElement('span'); s.className = cls; s.textContent = text; return s; }

  function buildCard(state, c) {
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'totes-addons__card'; b.setAttribute('data-key', c.key); b.setAttribute('aria-pressed', 'false');
    if (c.image) { var img = doc.createElement('img'); img.src = c.image; img.alt = ''; img.loading = 'lazy'; img.width = 160; img.height = 90; b.appendChild(img); }
    // [boss 2026-10-31] name and price on one line ("Zipper +$0.45"); a long name may wrap, the price follows it
    var line = span('totes-addons__card-line', '');
    line.appendChild(span('totes-addons__card-name', c.name));
    line.appendChild(doc.createTextNode(' '));
    line.appendChild(span('totes-addons__card-price', '+' + money(c.price)));
    b.appendChild(line);
    if (BY_KEY[c.key].hint) b.appendChild(span('totes-addons__card-hint', BY_KEY[c.key].hint));
    b.addEventListener('click', function () { toggle(state, c.key); });
    return b;
  }

  function buildCards(state) {
    state.cardsEl.replaceChildren();
    SECTIONS.forEach(function (sec) {
      var cards = [];
      DEFS.forEach(function (d) {
        if (sec.groups.indexOf(d.group) < 0) return;
        state.idx.cards.forEach(function (c) { if (c.key === d.key) cards.push(c); });
      });
      if (!cards.length) return;
      var head = doc.createElement('p'); head.className = 'totes-addons__group-title';
      head.textContent = sec.title;
      var grid = doc.createElement('div'); grid.className = 'totes-addons__cards';
      grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', sec.title);
      cards.forEach(function (c) { grid.appendChild(buildCard(state, c)); });
      state.cardsEl.appendChild(head); state.cardsEl.appendChild(grid);
    });
  }

  // Title row: the first chip this bag offers (CHIPS order), then "»" when other cards exist (boss 2026-10-31:
  // one chip only, so the row fits one line on a phone).
  function buildChip(state) {
    if (!state.chipsEl) return;
    var have = {};
    state.idx.cards.forEach(function (c) { have[c.key] = true; });
    state.chipsEl.replaceChildren();
    var chip = CHIPS.filter(function (ch) { return ch.keys.some(function (k) { return have[k]; }); })[0];
    if (!chip) return;
    var el = span('totes-addons__chip', '');
    el.innerHTML = chip.icon;   // constant markup defined above, never data
    el.appendChild(span('', chip.label));
    state.chipsEl.appendChild(el);
    if (state.idx.cards.some(function (c) { return chip.keys.indexOf(c.key) < 0; })) {
      var more = span('totes-addons__more', '»');
      more.setAttribute('aria-hidden', 'true');
      state.chipsEl.appendChild(more);
    }
  }

  function groupId() {
    var bytes = new Uint8Array(8);
    try { global.crypto.getRandomValues(bytes); } catch (e) { for (var i = 0; i < 8; i++) bytes[i] = Math.floor(Math.random() * 256); }
    return 'AO-' + Array.from(bytes, function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('').toUpperCase();
  }

  function hidden(form, name, value) {
    var n = doc.createElement('input'); n.type = 'hidden'; n.name = name; n.value = String(value);
    n.setAttribute('data-totes-addons-item', ''); form.appendChild(n);
  }

  function block(event, state, text) {
    event.preventDefault(); event.stopImmediatePropagation();
    if (state) notice(state, text);
  }

  // Capture listener on <product-form>: runs after artwork-dawn.js (document capture, adds artwork
  // properties) and before Dawn's own submit handler on the <form> (which builds FormData synchronously).
  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var scope = form.closest('product-info') || form.closest('section') || doc;
    var box = scope.querySelector('[data-totes-addons]'), state = box && boxes.get(box);
    if (!state || !state.selected.size) return;
    // [R2 P2-1 / R3 P2-1] Validate the submitted id/quantity FIRST — before the Woven Label auto-removal
    // can empty the selection — so a missing/invalid quantity never falls through to a plain bag add.
    // Quantity must be a positive whole number; never default it (fail-closed).
    var fd = new FormData(form), bagId = fd.get('id'), rawQty = fd.get('quantity');
    var qty = typeof rawQty === 'string' && /^\s*\d+\s*$/.test(rawQty) ? parseInt(rawQty, 10) : NaN;
    if (typeof bagId !== 'string' || !/^\d+$/.test(bagId) || !(qty > 0)) {
      return block(event, state, 'Please choose the bag options and enter a valid quantity first.');
    }
    enforceLabel(state, qty); render(state);
    var r = resolve(state);
    if (!r.names.length) return;   // only the label was chosen and a VALID quantity < 100 removed it: plain bag add
    if (!r.ok) return block(event, state, 'This add-on combination is not available right now. Please change your add-ons or contact us.');
    var bagProps = {}, bad = false;
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (!m) return;
      if (typeof v !== 'string') bad = true; else bagProps[m[1]] = v;
    });
    if (bad) return block(event, state, 'Add-ons cannot be combined with this upload. Please contact us.');
    var group = groupId(), variantTitle = (state.data.bagVariants || {})[String(bagId)] || '';
    // [Codex R19 blind P2-1, boss 2026-10-28] No "Add-ons" text on the bag line: it could not follow later cart
    // edits. The add-on lines themselves are the record; "For" names the bag and, if uploaded, its artwork file,
    // so two lines of the same bag/variant with different artwork can be told apart.
    // [Codex blind R2/R3 P3, boss 2026-10-28] Two different uploads can share a file name, so show a short design
    // code: the first 6 characters of the per-upload _design_id (24 hex, artwork-upload.js). The SAME code goes on
    // the bag line ("Design: #A1B2C3") and in the add-on lines' For ("(logo.png #A1B2C3)") so they can be matched.
    // It names the artwork, not the add-ons, so later cart edits can never make it wrong.
    // [rehearsal 2026-10-30] The live upload module prefixes the product line ("BAG-82F87C21…"): skip that prefix.
    var artwork = bagProps['Artwork File'], design = /^(?:[A-Z]{2,8}-)?([0-9A-F]{6})/.exec(bagProps._design_id || '');
    var code = artwork && design ? '#' + design[1] : '';
    if (code) bagProps.Design = code;
    var forText = state.data.bagTitle + (variantTitle ? ' – ' + variantTitle : '') +
      (artwork ? ' (' + artwork + (code ? ' ' + code : '') + ')' : '');
    bagProps._addon_group = group;
    // Cart shows the last-added line first, so send label, combo, bag => displays bag, combo, label.
    var items = [];
    if (r.label) items.push({id: r.label.id, props: {'For': forText, _addon_group: group}});
    if (r.combo) items.push({id: r.combo.id, props: {'For': forText, _addon_group: group}});
    items.push({id: bagId, props: bagProps, plan: fd.get('selling_plan')});
    // Top-level id/quantity are NOT ignored next to items[] (verified live: bag became qty+1), so disable them.
    var disabled = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if (el.name === 'id' || el.name === 'quantity' || el.name === 'selling_plan' || /^properties\[/.test(el.name)) {
        el.disabled = true; disabled.push(el);
      }
    });
    items.forEach(function (it, i) {
      hidden(form, 'items[' + i + '][id]', it.id);
      hidden(form, 'items[' + i + '][quantity]', qty);
      Object.keys(it.props).forEach(function (k) { hidden(form, 'items[' + i + '][properties][' + k + ']', it.props[k]); });
      if (it.plan) hidden(form, 'items[' + i + '][selling_plan]', it.plan);
    });
    // Dawn reads FormData synchronously in this same dispatch; restore the form right after it.
    global.setTimeout(function () {
      disabled.forEach(function (el) { el.disabled = false; });
      form.querySelectorAll('[data-totes-addons-item]').forEach(function (n) { n.remove(); });
    }, 0);
  }

  function mount() {
    doc.querySelectorAll('[data-totes-addons]').forEach(function (box) {
      var pf = scopeOf(box).querySelector('product-form');
      if (pf && !boundForms.has(pf)) { boundForms.add(pf); pf.addEventListener('submit', onSubmit, true); }
      if (boxes.has(box)) return;
      var data = parse(box);
      if (!data) return;
      var idx = index(data);
      if (!idx.cards.length) { box.hidden = true; return; }
      var state = {box: box, data: data, idx: idx, selected: new Set(),
        cardsEl: box.querySelector('[data-totes-addons-cards]'), noticeEl: box.querySelector('[data-totes-addons-notice]'),
        summaryEl: box.querySelector('[data-totes-addons-summary]'), chipsEl: box.querySelector('[data-totes-addons-chips]')};
      boxes.set(box, state);
      buildCards(state);
      buildChip(state);
      box.hidden = false;
      render(state);
    });
  }

  function onQuantity() {
    boxes.forEach(function (state) { if (state.box.isConnected) { enforceLabel(state); render(state); } });
  }

  global.TotesAddons = {
    mount: mount,
    // Add-on cents per bag for the (single) product form on the page; read by custom-price-calculator.js.
    perBagCents: function () {
      var total = 0;
      boxes.forEach(function (state) { if (state.box.isConnected) { var r = resolve(state); if (r.ok) total += r.cents; } });
      return total;
    },
    _resolve: resolve
  };
  doc.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') onQuantity(); });
  doc.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') onQuantity(); });
  function start() {
    mount();
    var scheduled = false;
    new MutationObserver(function (records) {
      if (scheduled || !records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
        return n.nodeType === 1 && (n.matches('[data-totes-addons], product-form') || n.querySelector('[data-totes-addons], product-form'));
      }); })) return;
      scheduled = true;
      global.queueMicrotask(function () { scheduled = false; mount(); });
    }).observe(doc.body, {subtree: true, childList: true});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
}(window, document));
